import { Fragment, Suspense } from "react"
import Home from "../../features/Search/views/Home"
import RbLoadingSpinner from "../../bosch-react/components/loading-spinner/RbLoadingSpinner"
import Upload from "../../features/Upload/views/Upload"
import SearchResults from "../../features/Search/views/SearchResults"
import { Route, Switch } from "react-router-dom"
import React from "react"
import _ from "lodash"
import AccessLoader from "../../features/AccessMediator/views/AccessLoader"
import MyBookmarks from "../../features/Bookmark/components/MyBookmarks"
import MyPendingReports from "../../features/Account/PendingUpload/MyPendingReports"
import MyApprovedUploads from "../../features/Account/ApprovedUpload/MyApprovedUploads"
import Management from "../../features/Admin/Management"
import Statistics from "../../features/Admin/Managements/Statistics/Statistics"
import GrantAccess from "../../features/Admin/GrantAccess/GrantAccess"
import MyPendingOrders from "../../features/Account/PendingOrder/MyPendingOrders"
import MyInCompleteUploads from "../../features/Account/IncompleteUpload/MyInCompleteUploads"
import MoveReport from "../../features/Admin/MoveSingleReport/MoveReport"
import MyApprovedOrders from "../../features/Account/ApprovedOrder/MyApprovedOrders"
import Subscriptions from "../../features/Subscriptions/components/Subscriptions"
import Department from "../../features/Admin/Managements/Department/Department"
import MoveReports from "../../features/Admin/Managements/Move/MoveReports"
import NotFound from "../../features/AccessMediator/components/NotFound"
import NotificationSetting from "../../features/Admin/NotificationSetting/NotificationSetting"
import AppSetting from "../../features/Admin/Managements/App/AppSetting"
import AlreadyRequestedPage from "../../features/AccessMediator/components/AlreadyRequestedPage"
import NonRnDUser from "../../features/AccessMediator/components/NonRnDUser"

export function renderRoute(propsParam: any, element: any) {
    if (!_.isNil(element.type)) {
        let newElement = React.cloneElement(element, { ...propsParam });
        return newElement;
    } else {
        return "";
    }
}

export const Router = () =>
    <Fragment>
        <Suspense
            fallback={
                <div className="ms-Grid">
                    <div className="ms-Grid-row">
                        <div
                            className="ms-Grid-col ms-sm12"
                            style={{ textAlign: "center", paddingTop: "35vh" }}
                        >
                            <RbLoadingSpinner size="1.5" />
                        </div>
                    </div>
                </div>
            }
        >
            <Switch>
                {/* Home */}
                <Route
                    exact={true}
                    path={process.env.REACT_APP_SEARCH}
                    render={(props) => renderRoute(props, <Home />)}
                />
                <Route
                    exact={true}
                    path={"/"}
                    render={(props) => renderRoute(props, <Home />)}
                />
                {/* Search Results */}
                <Route
                    path={`${process.env.REACT_APP_SEARCH_RESUTLS}`}
                    render={(props) => renderRoute(props, <SearchResults />)}
                />
                {/* Upload */}
                <Route
                    path={process.env.REACT_APP_UPLOAD}
                    render={(props) => renderRoute(props, <Upload />)}
                />
                {/* Access mediator */}
                <Route
                    path={`${process.env.REACT_APP_ACCESS_MEDIATOR}/:id/:mode?`}
                    render={(props) => renderRoute(props, <AccessLoader />)}
                />
                {/* My bookmarks */}
                <Route
                    exact={true}
                    path={`${process.env.REACT_APP_MY_BOOKMARKS}`}
                    render={(props) => renderRoute(props, <MyBookmarks />)}
                />
                {/* My pending uploads */}
                <Route
                    exact={true}
                    path={`${process.env.REACT_APP_MY_PENDING_REPORTS}`}
                    render={(props) => renderRoute(props, <MyPendingReports />)}
                />
                {/* My approved uploads */}
                <Route
                    exact={true}
                    path={`${process.env.REACT_APP_MY_APPROVED_UPLOADS}`}
                    render={(props) => renderRoute(props, <MyApprovedUploads />)}
                />
                {/* My pending orders */}
                <Route
                    exact={true}
                    path={`${process.env.REACT_APP_MY_PENDING_ORDERS}`}
                    render={(props) => renderRoute(props, <MyPendingOrders />)}
                />
                {/* My approved orders */}
                <Route
                    exact={true}
                    path={`${process.env.REACT_APP_MY_APPROVED_ORDERS}`}
                    render={(props) => renderRoute(props, <MyApprovedOrders />)}
                />
                <Route
                    exact={true}
                    path={`${process.env.REACT_APP_MY_INCOMPLETE_UPLOADS}`}
                    render={(props) => renderRoute(props, <MyInCompleteUploads />)}
                />
                {/* Management Dashboard */}
                <Route
                    exact={true}
                    path={`${process.env.REACT_APP_MANAGEMENT}`}
                    render={(props) => renderRoute(props, <Management />)}
                />
                {/* Management Statistic Data */}
                <Route
                    exact={true}
                    path={`${process.env.REACT_APP_STATISTICS}`}
                    render={(props) => renderRoute(props, <Statistics />)}
                />

                {/* Management Move multiple reports */}
                <Route
                    exact={true}
                    path={`${process.env.REACT_APP_MOVE_SINGLE}/:id`}
                    render={(props) => renderRoute(props, <MoveReport />)}
                />

                {/* Management Grant access */}
                <Route
                    exact={true}
                    path={`${process.env.REACT_APP_GRANT_ACCESS}`}
                    render={(props) => renderRoute(props, <GrantAccess />)}
                />
                <Route
                    exact={true}
                    path={`${process.env.REACT_APP_DEPARTMENTS}`}
                    render={(props) => renderRoute(props, <Department />)}
                />
                <Route
                    path={process.env.REACT_APP_ADMIN_UPLOAD}
                    render={(props) => renderRoute(props, <Upload mode={"admin"} />)}
                />
                <Route
                    path={process.env.REACT_APP_MY_SUBSCRIPTION}
                    render={(props) => renderRoute(props, <Subscriptions />)}
                />
                <Route
                    path={`${process.env.REACT_APP_MOVE}/:srcDep?/:objectId?`}
                    render={(props) => renderRoute(props, <MoveReports />)}
                />
                <Route
                    path={`${process.env.REACT_APP_NOTIFICATION_BAR}`}
                    render={(props) => renderRoute(props, <NotificationSetting />)}
                />
                <Route
                    path={`${process.env.REACT_APP_APP_SETTING}`}
                    render={(props) => renderRoute(props, <AppSetting />)}
                />
                <Route
                    path={`${process.env.REACT_APP_ALREADY_REQUESTED}`}
                    render={(props) => renderRoute(props, <AlreadyRequestedPage />)}
                />
                <Route
                    path={`${process.env.REACT_APP_NONE_RND_USER}`}
                    render={(props) => renderRoute(props, <NonRnDUser />)}
                />
                <Route
                    path={`${process.env.REACT_APP_NOT_FOUND}`}
                    render={(props) => renderRoute(props, <NotFound />)}
                />
                {/* <Route
                    path="*"
                >
                    <Home history={undefined} />
                </Route> */}
            </Switch>

        </Suspense>
    </Fragment>